module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-center-header'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid section"
  }, [_c('left-sidebar', {
    staticClass: "side-bar",
    class: {
      'open': _vm.isOpen
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid user-center-content"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('plex-footer', {
    staticClass: "phone-show"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43f71532!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/IndexMain.vue
// module id = 1309
// module chunks = 1